import React, { Component } from 'react';
import { connect } from 'react-redux';
import { array, number, func } from 'prop-types';
import { startSetTickets, markTicketAsRead } from '../../../actions/tickets';
import { TicketsPageView } from '../index';

class TicketsPage extends Component {
  static propTypes = {
    tickets: array.isRequired,
    total: number.isRequired,
    startSetTickets: func.isRequired,
    markTicketAsRead: func.isRequired,
  };

  static defaultProps = {
    tickets: [],
    total: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      params: {
        limit: 50,
        page: 0,
      },
      isTicketModalOpen: false,
      selectedTicketId: null,
    };

    this.cardHeaderRef = null;
  }

  componentDidMount() {
    this.getTickets();
  }

  getTicketParams() {
    return this.state.params;
  }

  getTickets() {
    this.setState(() => ({ loading: true }));
    this.props.startSetTickets(this.getTicketParams()).then(() => {
      this.setState(() => ({ loading: false }));
    });
  }

  toggleTicketModal = (ticketId = null) => {
    if (ticketId !== null) {
      this.props.markTicketAsRead(ticketId);
    }

    this.setState((prevState) => ({
      isTicketModalOpen: !prevState.isTicketModalOpen,
      selectedTicketId: ticketId,
    }));
  };

  changePage = (page) => {
    this.setState(
      (prevState) => ({
        params: {
          ...prevState.params,
          page: page,
        },
      }),
      () => {
        this.getTickets();
      },
    );
  };

  handleLimitChange = ({ target }) => {
    const { value: limit } = target;

    this.setState(
      (prevState) => ({
        params: {
          ...prevState.params,
          limit,
          page: 0,
        },
      }),
      () => {
        this.getTickets();
      },
    );
  };

  render() {
    const { limit, page } = this.getTicketParams();
    const { total, tickets } = this.props;
    const { isTicketModalOpen, selectedTicketId, loading } = this.state;

    let pageCount = Math.ceil(total / limit);

    const data = {
      tickets,
      total,
      loading,
      limit,
      page,
      pageCount,
      isTicketModalOpen,
      selectedTicketId,
    };

    return (
      <TicketsPageView
        data={data}
        cardHeaderRef={this.cardHeaderRef}
        changePage={this.changePage}
        handleLimitChange={this.handleLimitChange}
        toggleTicketModal={this.toggleTicketModal}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  tickets: state.tickets.tickets,
  total: state.tickets.total,
});

const mapDispatchToProps = (dispatch) => ({
  startSetTickets: (params) => dispatch(startSetTickets(params)),
  markTicketAsRead: (ticketId) => dispatch(markTicketAsRead(ticketId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketsPage);
